import React from 'react';

import { Label } from '@gravity-ui/uikit';
import { i18nRaw } from '@yandex-int/i18n';
import Caption from 'client/blocks/Form/Caption';
import Link from 'client/blocks/Link/Link';
import { CloudError } from 'client/types/cloud';
import * as keyset from 'i18n/SmartHomeForm';

const cloudConsoleUrl = 'https://console.cloud.yandex.ru';

const t = i18nRaw(keyset);

export const functionListErrorMessages: Record<CloudError, React.ReactNode> = {
    [CloudError.FAILED_PRECONDITION]: (
        <>
            <Link to={cloudConsoleUrl} target="_blank">
                {t('cloud-accept')}
            </Link>
        </>
    ),
    [CloudError.NOT_FOUND]: (
        <>
            <Link to={cloudConsoleUrl} target="_blank">
                {t('cloud-register')}
            </Link>
        </>
    ),
    [CloudError.INTERNAL]: (
        <Link to={`${cloudConsoleUrl}/support`} target="_blank">
            <Label theme="danger">{t('cloud-error')}</Label>
        </Link>
    ),
    [CloudError.PERMISSION_DENIED]: <Label theme="danger">{t('cloud-error-reload')}</Label>,
    [CloudError.INVALID_ARGUMENT]: <Label theme="danger">{t('cloud-error-reload')}</Label>,
    [CloudError.UNAUTHENTICATED]: <Label theme="danger">{t('cloud-error-reload')}</Label>,
    [CloudError.UNKNOWN]: (
        <Link to={`${cloudConsoleUrl}/support`} target="_blank">
            <Label theme="danger">{t('cloud-error')}</Label>
        </Link>
    ),
};

const validateFunctionDefaultMessage = t('cloud-error-access');

export const validateFunctionErrorMessages: Record<CloudError, React.ReactNode> = {
    [CloudError.PERMISSION_DENIED]: <>{t('cloud-denied')}</>,
    [CloudError.NOT_FOUND]: (
        <>
            <Link to={cloudConsoleUrl} target="_blank">
                {t('cloud-unavailable')}
            </Link>{' '}
        </>
    ),
    [CloudError.INTERNAL]: validateFunctionDefaultMessage,
    [CloudError.FAILED_PRECONDITION]: validateFunctionDefaultMessage,
    [CloudError.INVALID_ARGUMENT]: validateFunctionDefaultMessage,
    [CloudError.UNAUTHENTICATED]: validateFunctionDefaultMessage,
    [CloudError.UNKNOWN]: validateFunctionDefaultMessage,
};

export const emptyFunctionsDescription = (
    <Link to={cloudConsoleUrl} target="_blank">
        {t('cloud-no-functions')}
    </Link>
);

export const functionsCaption = <Caption>{t('cloud-tarif')}</Caption>;
